class MFRFeaturedMedia {
  constructor(i, e) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      video: ".video-item__item.embed" 
    };

    this.init();
  }

  init() {
    this.$video = this.$element.find(this.selectors.video);

    this.$video.find(".cover-image").on("click", this.__handlePlayEmbedVideo);
  }

  __handlePlayEmbedVideo(event) {
    const target = event.target;
    const parent =  $(this).closest(".video-item");
    const isActive = $(".video-item.is-playing");
    let iframe = [];

    if($(isActive).length > 0) {
      let iframeActive = [];

      if(/Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        iframeActive = $(isActive).find(".iframe-mobile iframe");
      } else {
        iframeActive = $(isActive).find(".iframe-desktop iframe");
      }

      let src = $(iframeActive).attr("src");
      src = src.replace("autoplay=1", "autoplay=0");
      $(iframeActive).attr('src', src); 

      $(isActive).removeClass("is-playing");
    }

    if($(target).hasClass("cover-image") || $(target).closest(".cover-image")) {
      if(/Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        iframe = $(parent).find(".iframe-mobile iframe");
      } else {
        iframe = $(parent).find(".iframe-desktop iframe");
      }

      let src = $(iframe).attr("src");
      src = src.replace("autoplay=0", "autoplay=1");
      $(iframe).attr('src', src);

      $(parent).addClass("is-playing");
    }
  }
}